export
const name: string = "LightingSimple";

export
const preproc: string = ``;

export
const declaration: string = `
    // be careful when working with structures, because on some mobile devices it is not possible to write to any structure

    // the light related code was inspired by http://www.john-chapman.net/content.php?id=3
    struct SLight {
              vec4 position; // in view space when the w component is zero, we have directional light
        lowp  vec3 diffuse;
        lowp  vec3 specular;
        lowp  float enabled;
        lowp  float fixed_pos;
    };

    const      int    MAX_LIGHT_SOURCES = 2;

    // required uniforms
    uniform       int    u_ambient_is_diffuse;
    uniform       float  u_minimal_diffuse_light; // for shadow volumes
    uniform       float  u_ambient_light_intensity;
    uniform       int    u_lights_count;
    uniform       SLight u_lights[MAX_LIGHT_SOURCES];

    lowp          vec3  diffuse;
    lowp          vec3  specular;
`;

export
const varyings: string = ``;

export
const implementation: string = `
    lowp vec4 applyLighting(const in SMaterial aSurfaceMaterial)
    {
        // when the ambient equals diffuse color uniform is enabled, then instead of using the surface ambient color, we use the diffuse color
        vec3 ambientSurfaceColor = aSurfaceMaterial.ambient;
        if (u_ambient_is_diffuse == 1) {
             ambientSurfaceColor = aSurfaceMaterial.diffuse;
        }

        diffuse  = vec3(0.0);
        specular = vec3(0.0);

        for (int i = 0; i < MAX_LIGHT_SOURCES; i++) {
            if (i < u_lights_count) {
                if (u_lights[i].enabled > 0.5) {
                    if (u_lights[i].position.w > 0.5) { // w = 1; local
                        /*if (u_lights[i].spot_exponent != 0.0) { // spot light
                            spot(surface, u_lights[i], results);
                        }
                        else { // point light
                            point(surface, u_lights[i], results);
                        }*/
                    }
                    else { // w = 0; directional
                        // this is for working shadow volumes (ambient pass + diffuse blend)
                        diffuse  += u_lights[i].diffuse;
                        specular += u_lights[i].specular;
                    }
                }
            }
        }

        return vec4(ambientSurfaceColor * u_ambient_light_intensity + aSurfaceMaterial.diffuse * diffuse + aSurfaceMaterial.specular * specular, aSurfaceMaterial.alpha * (1.0 - aSurfaceMaterial.transparency));
    }
`;
